export default __webpack_public_path__ + "static/media/money.6a92a1e4.svg";